import { AccountResultDto } from './account-result-dto.model';
import { BillToDto } from './bill-to-dto.model';
import { OpenReceivableDto } from './open-receivable-dto.model';

export class AccountsReceivableResultsDto {
  accountResultDto: AccountResultDto = new AccountResultDto();
  accountsReceivableResults: OpenReceivableDto[]  = [];
  BillToDto: BillToDto[] = [];
}
